exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.google-map[data-v-424d1810] {\n  width: 100%;\n  height: 100%;\n  margin: 0 auto;\n  background: gray;\n}\n", ""]);

// exports
